import DashboardActionTypes from 'app/redux-boneyard/dashboard/ActionTypes';
import reducer from 'app/redux-boneyard/dashboard/reducer';
import routes from 'app/dashboard/routes';

export default {
  reducers: {
    dashboard: reducer,
  },
  actionTypes: DashboardActionTypes,
  routes,
};
